// extracted by mini-css-extract-plugin
export default {"stars":"Stars_stars__btvQv","bad":"Stars_bad__ihBj-","normal":"Stars_normal__NXSUS","good":"Stars_good__oHyAS","great":"Stars_great__awbQq"};